module.exports = __webpack_public_path__ + "img/operation-icon-dark.500cbb5d.svg";